import React from 'react'
import { DateInput } from 'components/Wizard2/fieldComponents/Form'

export default ({value, onChange, ...props}) => {
  return (
    <div className="flume-calendar-input-wrapper">
      {
        props.label && <label>{props.label}</label>
      }
      <DateInput value={value} onChange={onChange} buttonClassName="flume-button" {...props} />
    </div>
  )
}
